import { Injectable } from '@angular/core';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

@Injectable()
export class InAppBrowserUtils {
  constructor() {}

  openUrl(url: string): void {
    if (Capacitor.isNativePlatform()) {
      Browser.open({ url });
    } else {
      // Check if running on iOS Safari
      const isIOSSafari =
        /iPad|iPhone|iPod/.test(navigator.userAgent) &&
        /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

      if (isIOSSafari) {
        // For iOS Safari, use location.href instead of window.open to avoid popup blocker
        window.location.href = url;
      } else {
        window.open(url, '_blank');
      }
    }
  }
}
